import hotel1 from "../../assests/hotel-1.png"
import hotel2 from "../../assests/hotel-2.png"
import hotel3 from "../../assests/hotel-3.png"

export const popularHotels = [
    {
        id:1,
        image: hotel1,
        title:"Silver Inn",
        categories:["Thai food", "African food", "Caribbean food"],
        delivery:"free",
        time:32,
        rate:4.2
    },
    {
        id:2,
        image: hotel2,
        title:"Hillside Retreat",
        categories:["Mexican food", "American food", "Italian food"],
        delivery:"free",
        time:22,
        rate:4.8
    },
    {
        id:3,
        image: hotel3,
        title:"Luxe Residences",
        categories:["Vegeterian", "Indian dishes", "French food"],
        delivery:"free",
        time:50,
        rate:4.1
    },
]